import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import QRCode from "qrcode";
import { api } from "../api";
import { useAuth } from "../auth";

export function QrPage() {
  const { me } = useAuth();
  // ヒアリング未回答でも QR は出す（受付を止めないため）。催促だけ行う。
  const needsHearing = !!me?.member && !me.member.hearingCompleted;
  const [dataUrl, setDataUrl] = useState<string | null>(null);
  const [exp, setExp] = useState<number | null>(null);
  const [err, setErr] = useState<string | null>(null);
  const [now, setNow] = useState<number>(Math.floor(Date.now() / 1000));

  const refresh = async () => {
    setErr(null);
    try {
      const r = await api.get<{ token: string; expiresAt: number }>(
        "/member/me/qr-token",
      );
      const url = await QRCode.toDataURL(r.token, { width: 320, margin: 1 });
      setDataUrl(url);
      setExp(r.expiresAt);
    } catch (e) {
      setErr((e as Error).message);
    }
  };

  useEffect(() => {
    refresh();
    const t = setInterval(() => setNow(Math.floor(Date.now() / 1000)), 1000);
    return () => clearInterval(t);
  }, []);

  const remain = exp != null ? Math.max(0, exp - now) : null;
  useEffect(() => {
    if (remain === 0) refresh();
  }, [remain]);

  return (
    <div className="card p-6 max-w-sm mx-auto text-center">
      <h2 className="font-bold text-tora">受付用 QR コード</h2>
      <p className="text-xs text-tora-ink/60 mt-1">
        スタッフに画面を提示してください。署名・有効期限付きです。
      </p>
      {needsHearing && (
        <div className="mt-3 rounded-lg bg-amber-50 border border-amber-300 p-3 text-left">
          <p className="text-xs text-amber-900 leading-relaxed">
            初回ヒアリングが未回答です。受付はこの QR でそのまま行えますが、
            お時間のあるときにご回答をお願いします（1〜2分）。
          </p>
          <Link
            to="/first-hearing"
            className="inline-block mt-2 text-xs font-bold text-tora underline"
          >
            ヒアリングに回答する →
          </Link>
        </div>
      )}
      {err && <p className="text-sm text-red-600 mt-3">{err}</p>}
      {dataUrl && (
        <img src={dataUrl} alt="QR" className="mx-auto mt-4" />
      )}
      {remain != null && (
        <p className="mt-3 text-xs text-tora-ink/60">
          残り {remain} 秒で更新されます
        </p>
      )}
      <button onClick={refresh} className="btn-outline mt-3">
        手動更新
      </button>
    </div>
  );
}
